import * as React from 'react'

const SvgUpIcon = (props) => (
  <svg
    width="14"
    height="9"
    viewBox="0 0 14 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.16634 7.5L6.99967 1.66667L12.833 7.5"
      stroke="url(#paint0_linear_1248_14395)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1248_14395"
        x1="12.833"
        y1="7.5"
        x2="6.27569"
        y2="-1.89822"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={`${props?.color ? props.color : '#FFFFFF'}`} />
        <stop
          offset="1"
          stopColor={`${props?.color ? props.color : '#FFFFFF'}`}
        />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgUpIcon
